import { Injectable, InjectionToken, inject } from '@angular/core';
import { WINDOW } from '@tvd/cdk/browser';

export interface AuthPlatformAdapter {
  persistSession(refreshToken: string, expiry: number): Promise<void>;
  clearSession(): Promise<void>;
  restoreSession(): Promise<{
    refreshToken: string | null;
    expiry: number | null;
  }>;
  redirectToLogin(): void;
  /**
   * Called synchronously at the top of `AuthService.logout()` while the access
   * token is still valid. Use it to fire authenticated cleanup requests (e.g.
   * unregister a push subscription). Implementations should not await — the
   * logout flow continues immediately and clears tokens.
   */
  beforeLogout?(): void;
}

@Injectable({ providedIn: 'root' })
export class WebAuthPlatformAdapter implements AuthPlatformAdapter {
  readonly #winRef = inject(WINDOW);

  async persistSession(): Promise<void> {}
  async clearSession(): Promise<void> {}
  async restoreSession() {
    return { refreshToken: null, expiry: null };
  }
  redirectToLogin(): void {
    this.#winRef.location.href = '/auth/login';
  }
}

export const AUTH_PLATFORM_ADAPTER = new InjectionToken<AuthPlatformAdapter>(
  'AUTH_PLATFORM_ADAPTER',
  {
    providedIn: 'root',
    factory: () => inject(WebAuthPlatformAdapter),
  },
);
